'use client'

import { TabsList } from '~/components/component-library/Tabs/components/TabsList'
import { TabsRoot } from '~/components/component-library/Tabs/components/TabsRoot'
import { TabsTrigger } from '~/components/component-library/Tabs/components/TabsTrigger'
import { type TabsProps } from '~/components/component-library/Tabs/types'
import { cn } from '~/utils/tailwind-utils'

export { TabsRoot } from '~/components/component-library/Tabs/components/TabsRoot'
export { TabsList } from '~/components/component-library/Tabs/components/TabsList'
export { TabsTrigger } from '~/components/component-library/Tabs/components/TabsTrigger'
export { TabsContent } from '~/components/component-library/Tabs/components/TabsContent'
export {
  type TabOption,
  type TabsListVariant,
} from '~/components/component-library/Tabs/types'

export const Tabs = ({
  children,
  options = [],
  className,
  ...props
}: TabsProps) => (
  <TabsRoot {...props} className={cn('space-y-6', className)}>
    <TabsList>
      {options.map(({ value, display, isDisabled }) => (
        <TabsTrigger key={value} value={value} isDisabled={isDisabled}>
          {display}
        </TabsTrigger>
      ))}
    </TabsList>
    {children}
  </TabsRoot>
)
